module.exports = __webpack_public_path__ + "b70b5406750d28c530afbe2c261e734f.jpg";